import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all cost_center_accounts
export const fetchCostCenterAccounts = createAsyncThunk("cost_center_accounts/fetchAll", async () => {
  try {
    const {data} = await axios.get(`${BASE_URL}/cost-center-accounts`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
        Lang: i18n.language,
      },
    });
     return Array.isArray(data?.data) ? data.data : [];
  } catch (error) {
    const message = error.response?.data?.message || "Failed load data";
    return message;
  }
});

// add cost_center_accounts
export const addCostCenterAccounts = createAsyncThunk(
  "cost_center_accounts/add",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/cost-center-accounts`, userData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue(message);
    }
  }
);
const CostCenterAccountsSlice = createSlice({
  name: "cost_center_accounts",
  initialState: {
    cost_center_accounts: [],
    record: null,
    isLoading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCostCenterAccounts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCostCenterAccounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cost_center_accounts = action.payload;
      })
      .addCase(fetchCostCenterAccounts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load data";
      })
      .addCase(addCostCenterAccounts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addCostCenterAccounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(addCostCenterAccounts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to add data";
      });
  },
});

export const { clearState } = CostCenterAccountsSlice.actions;
export default CostCenterAccountsSlice.reducer;
